<template>
  
  <div>

    <div class="ui grid">

      <div class="sixteen wide field m-t-15">
        <button class="ui mini basic button" @click="setRowsSelection(true)">
          <i class="check double blue icon"></i> Selecionar todos
        </button>
        <button class="ui mini basic button m-l-10" @click="setRowsSelection(false)">
          <i class="times red icon"></i> Remover seleção
        </button>
      </div>

      <div class="sixteen wide column">
        <table class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Número</th>        
              <th>Status</th>
              <th>Tipo</th>            
              <th>Cliente</th>
              <th>Vencimento</th>
              <th>Valor Título</th>
              <th>Valor Baixado</th>
              <th>Saldo</th>
              <th style="min-width: 250px !important;">Ação</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(receivable, index) in receivables" @click="onRowClick($event, index)">
              <td>
                <strong class="mobile-only">Número: </strong> 
                <i class="circle blue icon m-r-10" :class="{ outline: !receivable.selected, check: receivable.selected }"></i>
                {{ receivable.id }}
              </td>
              <td>
                <strong class="mobile-only">Status: </strong> 
                <span v-html="receivable.statusData.label"></span>
              </td>
              <td>
                <strong class="mobile-only">Tipo: </strong>
                <span v-html="receivable.typeData.label"></span>
              </td>            
              <td>
                <strong class="mobile-only">Cliente: </strong> {{ receivable.customer.shortName }}
              </td>
              <td :class="{ negative: receivable.isExpired }">
                <strong class="mobile-only">Vencimento: </strong> {{ $formatDate(receivable.realDueDate) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Título: </strong> {{ $formatCurrency(receivable.value) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Baixado: </strong> 
                {{ $formatCurrency(receivable.value - receivable.balance) }}
              </td>
              <td>
                <strong class="mobile-only">Saldo: </strong> {{ $formatCurrency(receivable.balance) }}
              </td>
              <td class="clickable" @click="onActionClick($event, index)">
                <div class="ui pointing dropdown text receivables-grid-dropdown" 
                  :class="{ blue: receivable.selected, grey: !receivable.selected }">
                  <span>{{ receivable.actionLabel }}</span>
                  <i class="caret down icon" style="margin-left: 3px;"></i> 
                  <div class="menu">
                    <div v-if="receivable.balance > 0" class="item" @click="onSetAction($event, index, 'full_settle')">
                      <i class="check circle green icon"></i>
                      Baixar saldo restante
                    </div>
                    <div v-if="receivable.balance > 0" class="item" @click="onSetAction($event, index, 'partial_settle')">
                      <i class="edit blue icon"></i>
                      Definir detalhes da baixa
                    </div>
                    <div v-if="receivable.balance < receivable.value" class="item" @click="onSetAction($event, index, 'undo')">
                      <i class="undo red icon"></i>
                      Estornar última baixa
                    </div>
                    <div class="item" @click="onSetAction($event, index, 'nothing')">
                      <i class="ban grey icon"></i>
                      Nenhuma ação
                    </div>
                  </div>
                </div>
              </td>
            </tr>                
          </tbody>
        </table>
      </div>

    </div>

    <value-modal ref="valueModal" :disableCompensation="true" @onConfirm="onConfirmValue" />

  </div>

</template>

<script>

  import ValueModal from "./value-modal"

  export default {
    
    name: "ReceivablesSettlesGrid",

    data() {
      return {
        receivables: [],
      }
    },

    components: {
      ValueModal,
    },
    
    methods: {

      setReceivables(receivables) {
        
        this.receivables = receivables.slice()

        receivables.forEach((receivable) => {
          receivable.action = "nothing"
          this.setActionData(receivable)
        })

        setTimeout(() => this.loadGridDropdowns(), 1000)
      },

      loadGridDropdowns() {
        $(".receivables-grid-dropdown").dropdown()
      },

      onRowClick($event, index) {

        $event.stopPropagation()

        let receivables = this.receivables.slice()
        let receivable = receivables[index]

        receivable.selected = !receivable.selected

        if (receivable.selected) {
          receivable.action = "full_settle"
        } else {
          receivable.action = "nothing"
        }

        this.setActionData(receivable)

        this.receivables = receivables.slice()
      },

      setRowsSelection(selected) {

        let receivables = this.receivables.slice()

        receivables.forEach((receivable) => {
          
          receivable.selected = selected
          
          if (selected && receivable.action == "nothing") {
            receivable.action = "full_settle"
          } else if (!selected) {
            receivable.action = "nothing"
          }

          this.setActionData(receivable)
        })

        this.receivables = receivables.slice()
      },

      onActionClick($event, index) {        
        $event.stopPropagation()
      },

      onSetAction($event, index, action) {

        $event.stopPropagation()

        $(".receivables-grid-dropdown").dropdown("hide")

        let receivables = this.receivables.slice()

        receivables[index].action = action

        if (action == "partial_settle")
          return this.$refs.valueModal.create(receivables[index])
        
        this.setActionData(receivables[index])

        this.receivables = receivables.slice()  
      },

      setActionData(receivable) {

        let label =  ""
        let selected = true
        let action = receivable.action

        if (action == "full_settle" && !receivable.balance)
          action = "nothing"

        if (action == "full_settle") {
          
          label = `Baixar o saldo de R$ ${this.$formatCurrency(receivable.balance)}`

        } else if (action == "compensate") {

          label = "Compensar..."
          
        } else if (action == "undo") {

          label = "Estornar última baixa"
          
        } else if (action == "nothing") {  

          selected = false
          label = "Nenhuma ação selecionada"
        }

        if (label) {
          receivable.actionLabel = label          
          receivable.selected = selected
        }  

        return label
      },

      onConfirmValue(data) {

        const { receivable, date, refDate, value, employee } = data

        let receivables = this.receivables.slice()
        let target = this.receivables.find((el) => el.id == receivable.id)

        receivables.forEach((el) => {
          if (el.id == receivable.id) {
            el.settleDate = date
            el.settleRefDate = refDate
            el.settleValue = value
            el.employee = employee
            el.action = "partial_settle"
            el.actionLabel = `Baixar R$ ${this.$formatCurrency(value)}`
            el.selected = true
          }
        })

        this.receivables = receivables.slice()
      },

      getSettles() {

        let settles = []

        this.receivables.forEach((receivable) => {

          if (!receivable.selected)
            return

          let { id, action, settleDate, settleRefDate, settleValue, balance, employee } = receivable
          
          if (action == "full_settle")
            settleValue = balance

          settles.push({ 
            receivableId: id, 
            action, 
            employee, 
            date: settleDate,
            refDate: settleRefDate,
            value: settleValue,
          })
        })

        return settles
      },
    },
  }

</script>